module.exports = __webpack_public_path__ + "img/selected4-min.996b8e24.png";